import React, { useState } from "react";
import {
	amounts,
	requiredFormData,
	designationData,
} from "../../../assets/data/donateData";
import { useForm } from "react-hook-form";
// import axios from "axios";
// import { toast } from "react-toastify";
import DetailContainer from "./components/DetailContainer";
import { SectionContainer } from "./SavePatientStyle";

export default function SavePatientSection() {
	const [donationDetails, setDonationDetails] = useState({
		amount: "",
		designation: "",
		comment: "",
	});

	const [selectedAmount, setSelectedAmount] = useState("");

	const selectAmount = (amount) => {
		setSelectedAmount(amount);

		setDonationDetails({ ...donationDetails, amount: amount });
	};

	const handleChange = (e) => {
		setDonationDetails({
			...donationDetails,
			[e.target.name]: e.target.value,
		});
	};

	const {
		register,
		handleSubmit,
		formState: { errors },
		// reset,
	} = useForm();

	const onSubmit = async (data) => {
		setDonationDetails({ ...donationDetails, ...data });
		console.log(donationDetails);

		// const config = {
		// 	method: "post",
		// 	url: "https://3h.stemtutorsonline.info/prayer-requests/create/",
		// 	headers: {
		// 		"Content-Type": "application/json",
		// 	},
		// 	data: data,
		// };
		// // //TODO post email(data) to api
		// try {
		// 	const response = await axios(config);
		// 	reset({
		// 		first_name: "",
		// 		last_name: "",
		// 		phone: "",
		// 		email: "",
		// 		subject: "",
		// 		request: "",
		// 	});
		// 	return response && toast.dark("Request Submitted!🎉");
		// } catch (error) {
		// 	console.log(error);
		// }
	};

	return (
		<SectionContainer>
			<p className="note">
				*This is a special donation to support those in the hospitals
				who need urgent medical attention and have financial
				difficulties especially when these costs are not covered by
				their insurance. The Board of HeadHeartHand Foundation will
				select individuals who match this criteria in consultation with
				the relevant hospitals/clinics. A quarterly report of this
				donation drive and utilization will be submitted to the review
				of all donors.
			</p>

			<div className="body-container">
				<div className="donation">
					<DetailContainer
						heading="Donation"
						description="Your generous support will go directly to providing
						support and assistance to our community’s most"
					/>

					<div className="donation-amounts">
						{amounts?.map((amount) => (
							<button
								key={amount}
								onClick={() => selectAmount(amount)}
								className={
									selectedAmount === amount
										? "selected"
										: undefined
								}
							>
								{amount}
							</button>
						))}
					</div>
				</div>

				<div className="designation">
					<DetailContainer
						heading="Designation"
						description="Your generous support will go directly to providing
							support and assistance to our community’s most"
					/>

					<form>
						<div className="input-container">
							<label htmlFor="designation"> Designation</label>

							<select
								className="form-select"
								aria-label="Default select example"
								name="designation"
								defaultValue={donationDetails.designation}
								onChange={handleChange}
							>
								{designationData?.map((value) => (
									<option value={value} key={value}>
										{value}
									</option>
								))}
							</select>
						</div>
						<div className="input-container">
							<label htmlFor="comment">
								Leave a comment (optional):
							</label>

							<textarea
								name="comment"
								id=""
								cols="30"
								rows="10"
								onChange={handleChange}
							></textarea>
						</div>
					</form>
				</div>

				<div className="billing-address">
					<DetailContainer
						heading="Billing Address"
						description="Your generous support will go directly to providing
						support and assistance to our community’s most"
					/>

					<form onSubmit={handleSubmit(onSubmit)} id="billing-form">
						{requiredFormData?.map(
							({ label, type, registerName, errorMessage }) => (
								<div className="input-container" key={label}>
									<label>{label}</label>

									<input
										type={type}
										{...register(registerName, {
											required: false,
										})}
									/>

									{errors.registerName &&
										(errorMessage !== "" ? (
											errorMessage
										) : (
											<span>This field is required</span>
										))}
								</div>
							)
						)}
					</form>
				</div>

				<div className="button-container">
					<button type="submit" form="billing-form">
						Submit
					</button>
				</div>
			</div>
		</SectionContainer>
	);
}
